import React from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, IconButton, Stack, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

/**
 * Modal premium OTRIX (regla de diseño): superficie off-black + hairline + radio 18px + sombra
 * teñida + header con título y X dorada al hover + zona de acciones. Úsalo SIEMPRE en vez de un
 * Dialog plano para mantener la estética (nada de modales grises sin borde).
 */
function PremiumModal({
  open,
  onClose,
  title,
  subtitle = null,
  icon = null,
  children = null,
  actions = null,
  maxWidth = 'sm'
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      slotProps={{ backdrop: { sx: { backdropFilter: 'blur(4px)', backgroundColor: 'rgba(0, 0, 0, 0.6)' } } }}
      PaperProps={{
        sx: {
          borderRadius: '18px',
          border: '1px solid',
          borderColor: 'hairline.strong',
          backgroundColor: 'surface.content',
          backgroundImage: 'none',
          boxShadow: 'var(--otx-card-shadow-hover)',
          overflow: 'hidden'
        }
      }}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2} sx={{ p: 3, pb: 2 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
          {icon && (
            <Box sx={{ display: 'flex', color: 'var(--otx-gold-text)' }}>{icon}</Box>
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: '-0.01em' }}>{title}</Typography>
            {subtitle && <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>{subtitle}</Typography>}
          </Box>
        </Stack>
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="cerrar"
          sx={{ color: 'text.secondary', mt: -0.5, mr: -0.5, '&:hover': { color: 'var(--otx-gold-text)', backgroundColor: 'action.hover' } }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>

      <Box sx={{ height: '1px', backgroundColor: 'hairline.main', mx: 3 }} />

      <Box sx={{ p: 3, pt: 2.5, maxHeight: '68vh', overflowY: 'auto' }}>{children}</Box>

      {actions && (
        <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1.5} sx={{ px: 3, pb: 3, pt: 0.5 }}>
          {actions}
        </Stack>
      )}
    </Dialog>
  );
}

PremiumModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  icon: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  maxWidth: PropTypes.string
};

export default PremiumModal;
